import { AddNewIcon, NoteIcon, SearchIcon } from 'app/agriculture/icons';
import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SkeletonButton } from 'app/agriculture/components/Button/SkeletonButton';
import { NoteRowSkeleton } from './components/NoteRowSkeleton';
import './components/NoteListHeader.scss';
import './components/NoteListComponent.scss';

export function NoteListSkeleton() {
    return (
        <ContentBox title="All Notes" Icon={NoteIcon}>
            <div className="NoteListContainer">
                <div className="NoteListHeader">
                    <div className="NoteListHeader__top">
                        <SkeletonButton startIcon={<AddNewIcon color="#eee" />} />
                        <SkeletonButton
                            startIcon={<SearchIcon color="#ccc" />}
                            variant="textonly"
                        />
                    </div>
                </div>
                <div className="NoteList">
                    <NoteRowSkeleton />
                    <NoteRowSkeleton />
                    <NoteRowSkeleton />
                </div>
            </div>
        </ContentBox>
    );
}
